import request from '@/utils/request'

export function getMonitorInfo() {
  return new Promise((resolve, reject) => {
    request({
      url: '/monitor.getMonitorInfo',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
